import profile1 from '../../../Assets/Cards/profile1-1.png';
import profile2 from '../../../Assets/Cards/profile2.png';
import profile3 from '../../../Assets/Cards/profile3.png';
import profile4 from '../../../Assets/Cards/profile4.png';
import profile5 from '../../../Assets/Cards/profile5.png';
import profile6 from '../../../Assets/Cards/profile6.png';

export const profiles = [
    {
        image:profile1,
        title:"Client"
    },
    {
        styles:"list-item up",
        image:profile2,
        title:"Developer"
    },
    {
        image:profile3,
        title:"Manager"
    },
    {
        styles:"list-item up",
        image:profile4,
        title:" Designer"
    },
    {
        image:profile5,
        title:" Manager"
    },
    {
        styles:"list-item up",
        image:profile6,
        title:"Art Director"
    }
]